import React from 'react';

import { SVGPropsType } from 'src/types';

function Flash(props: SVGPropsType) {
    const { fill = '#FFAF12', onClick, style, className } = props;

    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M7.58333 1.16699L1.75 8.16699H7L6.41667 12.8337L12.25 5.83366H7L7.58333 1.16699Z"
                fill={fill}
            />
        </svg>
    );
}

export default Flash;
